<template>
    <div class="page">
        <div class="baner-subpage">
            <div class="container">
                <div class="text">Judaszowce, lecz nie tylko ...</div>
            </div>
        </div>
        <div class="content">
            <div class="container">
                <h2 class="pageHeader text-center">
                    Szpalery formowane
                </h2>
                <div class="cms text-center">
                    Wychodząc naprzeciwko zapotrzebowaniu w naszych ogrodach na nowoczesne rozwiązania architektoniczne, przykładowo zastępujące nadmierne stosowanie "tuji" i innych roślin iglastych w formie żywopłotów, proponujemy naszym klientom rozwiązania w postaci gotowych szpalerów roślinnych. Stosujemy w tym celu przede wszystkim graby (carpinus), poza tym wiązy (ulmus), buki (fagus), dęby (quercus) które rozpinamy na bambusowych ramkach uzyskując różnej formy i wielkości gotowe " ekrany ".<br/>
                    Jeśli zechcą Państwo zasłonić taras, śmietnik, psią budę itp. lub po prostu uzyskać formę typowego żywopłotu, prosimy zapoznać się z naszą ofertą.<br/>
                    Elementy uzyskane w ten sposób są nie tylko efektywne ale i nieprzeciętnie efektowne.<br/>
                    <br/><br/>
                </div>
                <div class="galeria">

                    <div class="row">
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_1_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_1.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_2_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_2.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_3_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_3.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_4_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_4.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_5_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_5.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_6_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_6.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <a data-gall="Galeria" href="/static/img/szpalery/szapler_7_big.jpg" title="Szpalery formowane - Galeria">
                                <img class="img-fluid" src="/static/img/szpalery/szapler_7.jpg" alt="Szpalery formowane - Galeria"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import 'owl.carousel/dist/owl.carousel.js'
    import 'owl.carousel/dist/assets/owl.carousel.min.css'
    import 'owl.carousel/dist/assets/owl.theme.default.min.css'
    import '../../static/plugins/venobox/venobox.css'
    import '../../static/plugins/venobox/venobox.js'
    export default {
        components: {



        },
        methods: {

        },
        mounted: function () {
            $(".galeria a").venobox();

        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Szpalery.vue